// pages/Services.js
import React from 'react';
import { Car, Calendar, Shield, DollarSign, Clock, MapPin } from 'lucide-react';
import { IndianRupee } from "lucide-react";

const Services = () => {
  return (
    <div className="page">
      {/* <section className="services-hero">
        <div className="services-hero-content">
          <h1>Our <span className="highlight">Services</span></h1>
          <p className="subtitle">Comprehensive carpooling solutions for every need</p>
        </div>
      </section> */}
      
      <section className="services-content">
        <div className="services-intro">
<h1>
  How <span style={{ color: "#184080"}}>Drivve&trade;</span> Works?
</h1>
          <p style={{ fontSize: "20px"}}>Drivve&trade; offers a seamless carpooling experience for both drivers and riders.<br/> Our platform connects commuters with similar routes, making travel more efficient and enjoyable.</p>
        </div>
        
        <div className="services-process">
          <div className="process-step">
            <div className="step-icon">
              <MapPin size={28} />
            </div>
<h3 style={{marginBottom: "0.5rem"}}>Define your route</h3>            <p>Enter your starting point and destination. Our smart algorithm finds matches along your route.</p>
          </div>
          
          <div className="process-step">
            <div className="step-icon">
              <Calendar size={28} />
            </div>
            <h3 style={{marginBottom: "0.5rem"}}>Schedule Rides</h3>
            <p>Choose your preferred time and schedule. Set recurring rides for daily commutes.</p>
          </div>
          
          <div className="process-step">
            <div className="step-icon">
              <Car size={28} />
            </div>
            <h3 style={{marginBottom: "0.5rem"}}>Match & Connect</h3>
            <p>Connect with verified users going your way. Chat with matches before confirming.</p>
          </div>
          
          <div className="process-step">
            <div className="step-icon">
          <IndianRupee size={28} />
            </div>
            <h3 style={{marginBottom: "0.5rem"}}>Share Costs</h3>
            <p>Split costs automatically. Payments are secure and handled through the app.</p>
          </div>
        </div>
        
        <div className="service-types">
          <h1 style={{ color: "#184080", textAlign: "center"}}>What we offer?</h1>
          <div className="service-cards">
            <div className="service-card">
              
              <h3>Daily Commute</h3>
              <p>Perfect for regular office commutes. Set up recurring rides with the same group for consistency.</p>
              <ul className="service-features">
                <li>Recurring ride schedules</li>
                <li>Same-group matching</li>
                <li>Flexible timing options</li>
              </ul>
            </div>
            
            <div className="service-card">
              
              <h3>One-Time Rides</h3>
              <p>Need a ride for a specific occasion? Find matches for one-time trips easily.</p>
              <ul className="service-features">
                <li>Event transportation</li>
                <li>Airport transfers</li>
                <li>Special occasion rides</li>
              </ul>
            </div>
            
            <div className="service-card">
             
              <h3>Corporate Solutions</h3>
              <p>Custom carpooling programs for businesses to reduce parking needs and carbon footprint.</p>
              <ul className="service-features">
                <li>Employee commute programs</li>
                <li>Dedicated support</li>
                <li>Reporting & analytics</li>
              </ul>
            </div>
          </div>
        </div>
    <div
  style={{
    width: "100%",
    background: "#ffffff",
  }}
>
  <h2
    style={{
      color: "#184080",
      fontSize: "clamp(30px,4vw,46px)",
      fontWeight: "700",
      textAlign: "center",
    }}
  >
    Ride Options
  </h2>

  <div
    style={{
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "center",
      gap: "clamp(25px,4vw,60px)",
      width: "100%",
    }}
  >
    {/* Rider */}
    <div
      style={{
        flex: "1 1 340px",
        maxWidth: "460px",
        background: "#fff",
        padding: "clamp(28px,4vw,48px)",
        borderRadius: "24px",
        boxShadow: "0 18px 50px rgba(0,0,0,0.06)",
        transition: "0.35s ease",
        cursor: "pointer",
      }}
      onMouseOver={(e) => {
        if (window.innerWidth > 768) {
          e.currentTarget.style.transform = "translateY(-14px)";
          e.currentTarget.style.boxShadow =
            "0 28px 70px rgba(0,0,0,0.12)";
        }
      }}
      onMouseOut={(e) => {
        e.currentTarget.style.transform = "translateY(0)";
        e.currentTarget.style.boxShadow =
          "0 18px 50px rgba(0,0,0,0.06)";
      }}
    >
      <h2 style={{ color: "#130F0F", fontSize: "clamp(24px,3vw,32px)" }}>
        Rider
      </h2>

      <p style={{ color: "#130F0F", marginBottom: "22px" }}>
        Pay only for the rides you take. No subscription fees.
      </p>

      <ul style={{ listStyle: "none", padding: 0 }}>
        {[
          "Pay per ride",
          "No monthly fees",
          "Cancel anytime",
          "All safety features included",
        ].map((item, i) => (
          <li
            key={i}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              margin: "13px 0",
            }}
          >
            <span style={{ color: "#184080", fontWeight: "bold" }}>✔</span>
            {item}
          </li>
        ))}
      </ul>
    </div>

    {/* Driver */}
    <div
      style={{
        flex: "1 1 340px",
        maxWidth: "460px",
        background: "#fff",
        padding: "clamp(28px,4vw,48px)",
        borderRadius: "24px",
        boxShadow: "0 20px 60px rgba(24,64,128,0.10)", // subtle brand glow instead of border
        transition: "0.35s ease",
        cursor: "pointer",
      }}
      onMouseOver={(e) => {
        if (window.innerWidth > 768) {
          e.currentTarget.style.transform = "translateY(-14px)";
          e.currentTarget.style.boxShadow =
            "0 30px 80px rgba(24,64,128,0.18)";
        }
      }}
      onMouseOut={(e) => {
        e.currentTarget.style.transform = "translateY(0)";
        e.currentTarget.style.boxShadow =
          "0 20px 60px rgba(24,64,128,0.10)";
      }}
    >
      <h2 style={{ color: "#130F0F", fontSize: "clamp(24px,3vw,32px)" }}>
        Driver
      </h2>

      <p style={{ color: "#130F0F", marginBottom: "22px" }}>
        Earn money by offering empty seats in your vehicle.
      </p>

      <ul style={{ listStyle: "none", padding: 0 }}>
        {[
          "Keep 100% of each fare",
          "Flexible scheduling",
          "Driver protections",
          "Route optimization",
        ].map((item, i) => (
          <li
            key={i}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              margin: "13px 0",
            }}
          >
            <span style={{ color: "#184080", fontWeight: "bold" }}>✔</span>
            {item}
          </li>
        ))}
      </ul>
    </div>
  </div>
</div>

      </section>
    </div>
  );
};

export default Services;